import { supabase } from '../supabaseClient';
import { purgeUserScopedCaches } from './userScopedCache';

export function clearSupabaseAuthStorage() {
  try {
    Object.keys(localStorage)
      .filter(key => (
        key.startsWith('sb-') ||
        key === 'supabase.auth.token' ||
        key.includes('auth-token')
      ))
      .forEach(key => localStorage.removeItem(key));
  } catch {
    /* ignore storage access failures */
  }
}

export async function clearSiteScopeSession() {
  let sessionKey = null;
  try {
    sessionKey = sessionStorage.getItem('ss_session_key');
  } catch {
    /* ignore storage access failures */
  }

  if (sessionKey) {
    try {
      await supabase
        .from('user_sessions')
        .delete()
        .eq('session_id', sessionKey);
    } catch {
      /* sign-out should continue even if session cleanup fails */
    }
  }

  try { sessionStorage.clear(); } catch { /* ignore */ }

  try {
    [
      'ss_pa_key',
      'ss_share_redirect',
      'ss_pending_deeplink',
      'ss_signup_from_share',
    ].forEach(key => localStorage.removeItem(key));
  } catch {
    /* ignore storage access failures */
  }

  // Remove every account-scoped cache so the next user on this browser never
  // hydrates from the signed-out user's cached pipeline/zones/pro data (WP-19).
  purgeUserScopedCaches();

  clearSupabaseAuthStorage();

  if ('caches' in window) {
    try {
      const names = await caches.keys();
      await Promise.all(
        names.filter(name => name.startsWith('sitescope')).map(name => caches.delete(name))
      );
    } catch {
      /* ignore cache cleanup failures */
    }
  }
}

export async function signOutAndClearSiteScopeSession() {
  try {
    const { error } = await supabase.auth.signOut({ scope: 'local' });
    if (error) console.warn('[SiteScope] Supabase sign-out returned an error:', error.message);
  } catch (err) {
    console.warn('[SiteScope] Supabase sign-out failed; clearing local session anyway:', err);
  } finally {
    await clearSiteScopeSession();
  }
}
